export default __webpack_public_path__ + "static/media/gal-1.24e5a4c7.jpg";